(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/views/draw-selector.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/views/draw-selector.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.maltipset.views.DrawSelector = Marionette.View.extend({
    template: function(data) {
      return svs.maltipset.templates.draw_selector(data);
    },
    ui: {
      menuExpand: '.js-expand-draw-menu',
      chevron: '.js-expand-draw-menu i'
    },
    className: function() {
      var className = 'panel panel-default panel-drawselector';

      if (svs.core.detect.formfactor.mobile()) {
        className += ' draw-selector-closed';
      }

      return className;
    },
    events: {
      'click @ui.menuExpand': 'toggleDraws',
      'click a': 'openDraw'
    },
    toggleDraws: function() {
      this.$el.toggleClass('draw-selector-closed');
      this.ui.chevron.toggleClass('icon-menu-down').toggleClass('icon-menu-up');
    },
    openDraw: function() {
      var drawNum = $(arguments[0].currentTarget).data('drawnum');

      Backbone.history.navigate('spela/' + drawNum, { trigger: true });
      return false;
    }
  });
})(Backbone, _, svs);


 })(window);